module.exports = __webpack_public_path__ + "img/wolf-level-shadow.441723c8.svg";